export default "__VITE_ASSET__CBtmpFg8__"